import React from "react";
import BaseComponent from "../BaseComponent";
import Input from "../Input";
import Dropdown from "../Dropdown";
import Button from "../Button";
import { Constant } from '../../const';
import Utility from "../../utilities/Utility";


export default class ReturnSubCon extends BaseComponent {
    /**
     * Submenu view for return value definition lists (outputs)
     * @module ReturnSubCon
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
        this.knownType = false;
        this.varModel = this.isKnownModel() ? this.props.data.variable : this.initVarModel();
        this.varIdx = (this.props.data && this.props.data.varIdx) ? this.props.data.varIdx : 0;
    }

    /**
     * Initialize dummy data model
     * @returns {Object}
     */
    initVarModel(){
        return {
            varName: null,
            type: null,
            id:Utility.uuid4(),
            sensitiveData:false,
            
        };
    }

    componentWillMount(){
        this.checkKnownVariable();
    }

    checkKnownVariable(){
        // Update variable type too if variable already exists
        this.knownType = false;
        this.varScope = '';
        if (this.varModel.varName){
            var sv = this.varModel.varName.split(".");
            if (sv.length === 1){
                sv = [Constant.k.SCOPE_MODULE, this.varModel.varName];
            }
            if (sv[0] === Constant.k.SCOPE_MODULE){
                const modId = window.apm.getCurrentDiagramWidget().props.node.id;
                const v = window.apm.getVariable(sv[1], modId);
                if (v){
                    this.knownType = true;
                    this.varModel.type = v.props.config.type;
                }
                else {
                    this.varScope = 'mod';
                }
            }
            if (sv[0] === Constant.k.SCOPE_APPLICATION){
                const v = window.apm.getVariable(sv[1]);
                if (v){
                    this.knownType = true;
                    this.varScope = 'app';
                    this.varModel.type = v.props.config.type;
                    this.varModel.id= v.id;
                    this.varModel.sensitiveData=v.props.config.sensitiveData;
                }
            }
        }
    }

   

    /**
     * Set config proxy; catches own input value updates and update its data model before saving to list
     * @param {string} key
     * @param {string|boolean} value
     */
    setConfig(key, value){
        this.varModel[key] = value;

        if (key === "varName"){
            this.checkKnownVariable();
            
        }
    }

    getConfig(key){
        return this.varModel[key];
    }

    isKnownModel(){
        return this.props.data && this.props.data.variable;
    }

    isValidModel(){
        return this.varModel.varName && (this.varModel.type || this.knownType);
    }

    remove(){
        this.props.context.remove(this.varIdx);
        this.varModel = this.initVarModel();
        this.props.domContext.removeSubmenu();
    }

    update(){
        if (this.isValidModel()){
            
            this.props.context.update(this.varModel, this.varIdx);
        }
        this.varModel = this.initVarModel();
        this.props.domContext.removeSubmenu();
    }

    add(){
        if (this.isValidModel()) {
           
            // Add current data model to item list
            this.props.context.add(this.varModel);
        }
        this.varModel = this.initVarModel();
        this.props.domContext.removeSubmenu();
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const preSelection = window.apm.knowledgeBase.getVariableTypeIndexFromValue(this.varModel.type);

        return (
            <div>
                {<Input 
                    label={this.getPropLabel("scoped_variable_name")} 
                    hint={this.getPropLabel("scoped_variable_name_hint")} 
                    value={this.varModel.varName} 
                    valRules={{ "noEmpty": true, "varName": true }}
                    context={this} 
                    valKey={"varName"} 
                    suggestion={"variable"}
                    suppressUpdate={true}
                />}

                {!this.knownType && this.varScope!=="mod"&&
                    <Dropdown 
                        wide={true} 
                        label={this.getPropLabel("variable_type")} 
                        optionName={this.getPropLabel("type_opt")}
                        options={window.apm.knowledgeBase.getVariableTypes()}
                        context={this} 
                        valKey={"type"}
                        selection={preSelection}
                        suppressUpdate={true} 
                    />
                }
                {(() => {
                    if (this.isKnownModel()) {
                        // Display edit and delete for editing
                        return (
                            <div style={{width: "100%", display: "flex", justifyContent: "space-around"}}>
                                <div>
                                    <Button 
                                        icon={"icon-trash"} 
                                        tint={"warning"}
                                        callback={() => {
                                            this.remove();
                                        }}
                                    />
                                </div>
                                <div>
                                    <Button 
                                        label="Save" 
                                        wide={true}
                                        callback={() => {
                                            this.update();
                                        }}
                                    />
                                </div>
                            </div>

                        );
                    }
                    return (
                        <Button label={this.getPropLabel("add_argument")} wide={true}
                                callback={() => {
                                    if (this.isValidModel()) {
                                        this.add();
                                    }
                                        this.props.domContext.removeSubmenu();
                                }}
                        />
                    );
                })()}
            </div>
        );
    }
}